
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListFertilisersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterFertilisersInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filterFertilisers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_liquid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"boron"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calcium"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chlorine"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"copper"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iron"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"potassium"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"magnesium"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manganese"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"molybdenum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nitrogen"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nickel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phosphorus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sulphur"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"selenium"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zinc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additives"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additive"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":602}};
    doc.loc.source = {"body":"query ListFertilisersQuery($input: FilterFertilisersInput) {\n  filterFertilisers(input: $input) {\n    data {\n      id\n      name\n      is_liquid\n      type\n      boron\n      calcium\n      chlorine\n      copper\n      iron\n      potassium\n      magnesium\n      manganese\n      molybdenum\n      nitrogen\n      nickel\n      phosphorus\n      sulphur\n      selenium\n      zinc\n      deleted_at,\n      additives {\n        id #the relation id\n        percentage\n        additive {\n          id\n          name\n        }\n      }\n    }\n    meta {\n      page\n      total\n      limit\n      from\n      to\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ListFertilisersQuery"] = oneQuery(doc, "ListFertilisersQuery");
        
